import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicLagrangePDE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SOLVING LINEAR PDE USING LAGRANGE'S METHODS"
      videos={[
        "https://www.youtube.com/embed/41U-i1Q7se0",
        "https://www.youtube.com/embed/hh5F33K15zQ",
        "https://www.youtube.com/embed/DYEIA7B5B_A",
        "https://www.youtube.com/embed/CK3XzLYZ1oc",
      ]}
      takeaways={[
        { text: "Method of grouping:" },
        { text: "- First video: How to solve" },
        { text: "- Second video: Sample problem" },
        { text: "Method of multiplier:" },
        { text: "- Third video: How to solve" },
        { text: "- Fourth video: Sample problem" },
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicLagrangePDE;